import React from 'react';
import { Form } from 'react-bootstrap-5';

import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsUp } from '@fortawesome/pro-solid-svg-icons';

import Controls from './controls';

function BetaSignup({ profile, onBack, onValueChange, onSave }) {
  const save = (e) => {
    e.preventDefault();
    onSave();
  };

  const label = profile.betaUser ?
    'Yes, I would like to enroll in Beta.' :
    `No, I would not like to enroll in Beta.`;

  return (
    <form onSubmit={save}>
      <div className="mb-2">
        <FontAwesomeIcon icon={faThumbsUp} size="2x" />
      </div>
      <h5 className="mb-4">Enroll in our beta/feedback program</h5>

      <div className="mb-4">
        <Form.Label className="m-0">Would you like to help make our product the best it can be?</Form.Label>
        <div>
          Our Beta Program will give you early access to new features that we're working on to test out
          and provide feedback early.
          Us learning how you use these new features or workflows will help influence what's released
          to everyone at the time of launch.
        </div>
      </div>

      <div className="mb-4">
        <Form.Check
          checked={profile.betaUser}
          className="form-switch-lg mb-2"
          label={label}
          type="switch"
          onChange={e => onValueChange('betaUser', e.target.checked)}
        />
        <div className="small text-muted">
          Note: these features are not guaranteed
        </div>
      </div>

      <Controls
        showSave
        onBack={onBack}
        onSave={onSave}
      />
    </form>
  );
}

BetaSignup.propTypes = {
  profile: PropTypes.shape({
    betaUser: PropTypes.bool.isRequired
  }).isRequired,
  onBack: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onValueChange: PropTypes.func.isRequired
};

export default BetaSignup;